import { DATE_OF_NEXT_AUDIT_TAG } from "../dynamicForm/types";
import {
  isUnansweredMandatoryQuestionsError,
  missingQuestionIds,
  type RegistrationStatus,
} from "../api/registrations.types";

export const statusFormProps = (
  record: { status: RegistrationStatus },
  statusError: unknown,
  mandatoryQuestionErrorMessage: string
) => ({
  disableQuestionsByTag: { [DATE_OF_NEXT_AUDIT_TAG]: record.status.status === "audit" },
  missingQuestionIds: missingQuestionIds(statusError),
  mandatoryQuestionErrorMessage: isUnansweredMandatoryQuestionsError(statusError)
    ? mandatoryQuestionErrorMessage
    : undefined,
});
